module.exports = __webpack_public_path__ + "img/zoom_out-24px.f7af6c57.svg";